// The six of us. Ids are stable and used as database document keys —
// changing one orphans that person's availability, schedule and reading checks.

export const PEOPLE = [
  { id: "pun", name: "Pun Na Ranong", short: "Pun", ini: "PN" },
  { id: "ivi", name: "Ivi Zorgno", short: "Ivi", ini: "IZ" },
  { id: "charlie", name: "Charlie Bertlett", short: "Charlie", ini: "CB" },
  { id: "anthony", name: "Anthony Kriezis", short: "Anthony", ini: "AK" },
  { id: "rahul", name: "Rahul Pai", short: "Rahul", ini: "RP" },
  { id: "sofia", name: "Sofia Aicardi", short: "Sofia", ini: "SA" },
];

/** Lookup by id. `P[id]` is undefined for a stale id — always guard. */
export const P = Object.fromEntries(PEOPLE.map((p) => [p.id, p]));

export const TEAM_NAME = "IO Herons";
export const COHORT = "Herons, Indian cohort";
